/**
 * Single entrypoint for area route builders. Import `routes` and call through
 * the hierarchy: `routes.projects.apps.deployment(scope)`. New areas register
 * here as they get builders.
 */
import { accountRoutes } from "./account";
import { apiKeyRoutes } from "./api-keys";
import { auditRoutes } from "./audit";
import { authRoutes } from "./auth";
import { projectRoutes } from "./projects";
import { settingsRoutes } from "./settings";
import { workspaceRoutes } from "./workspaces";

export { buildRoute } from "./shared";
export type { CheckoutIntent, DeployCheckoutOrigin, DeployCheckoutPlan } from "./settings";
export { DEPLOY_CHECKOUT_ORIGINS } from "./settings";

export const routes = {
  account: accountRoutes,
  projects: projectRoutes,
  apiKeys: apiKeyRoutes,
  settings: settingsRoutes,
  audit: auditRoutes,
  auth: authRoutes,
  workspaces: workspaceRoutes,
};
